import React, { useEffect, useState } from "react";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";
import { MaterialReactTable } from "material-react-table";
import { AiOutlineInfoCircle } from "react-icons/ai";
import UserInfoModal from "components/UserInfoModal/UserInfoModal";
import { avtar } from "utils/images";
import { useLocation } from "react-router-dom";
import getStatusTextColor from "components/StatusColorFunction/StatusColorFunction";
import GoBackButton from "components/GoBackButton/GoBackButton";
export default function HotelEnquiryHistory({ History }) {
  const location = useLocation();
  const historydata = History || location.state;

  const [data, setData] = useState(historydata?.reverse() || []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userProfile, setUserProfile] = useState({});

  const handleOpenModal = (assignedUser) => {
    setUserProfile(assignedUser);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);

    setUserProfile({}); // Reset user profile on close
  };

  // Utility function to format a date as DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "Invalid Date"; // Handle invalid date inputs

    // Format date to DD-MM-YYYY
    const formattedDate = dateObj
      .toLocaleDateString("en-GB")
      .replace(/\//g, "-");
    return formattedDate;
  };
  // Column definitions for the table
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "enquiry_code",
        header: "Enquiry ID",
        enableColumnFilter: false, // Disable filter for this column
      },
      // {
      //   accessorKey: "title",
      //   header: "Title",
      //   Cell: ({ cell, row, table }) => {
      //     const currentValue = cell.getValue(); // current row's "title" value
      //     const currentRowIndex = row.index;

      //     // Check if there is a next row to compare against and ensure it's not the last row
      //     const nextValue =
      //       currentRowIndex < table.getRowModel().rows.length - 1
      //         ? table.getRowModel().rows[currentRowIndex + 1]?.original?.title
      //         : null;

      //     // Check if the current value is different from the next row's value, but don't change color for the last row
      //     const isDifferent =
      //       nextValue !== currentValue &&
      //       currentRowIndex < table.getRowModel().rows.length - 1;

      //     return (
      //       <span className={isDifferent ? "text-purple-500" : ""}>
      //         {currentValue || "N/A"}
      //       </span>
      //     );
      //   },
      // },
      {
        accessorKey: "full_name",
        header: "Customer Name",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "full_name" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.full_name
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      {
        accessorKey: "email",
        header: "Email Address",
        enableClickToCopy: true,
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "email" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original?.email
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      {
        accessorKey: "phone_number",
        header: "Phone Number",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "phone_number" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.phone_number
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },

      {
        accessorKey: "enquirySource",
        header: "Enquiry Source",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue()?.name || "N/A"; // Ensure we get the name, or "N/A" if missing
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.enquirySource?.name
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue}
            </span>
          );
        },
      },
      // {
      //   accessorKey: "invoice_number",
      //   header: "Invoice",
      //   Cell: ({ cell }) => cell.getValue() || "N/A",
      //   enableColumnFilter: true, // Enable filter for this column
      // },
      {
        accessorKey: "destination",
        header: "Destination",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "destination" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.destination
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      {
        accessorKey: "check_in_date",
        header: "Check In Date",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "check_in_date" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.check_in_date
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      {
        accessorKey: "check_out_date",
        header: "Check Out Date",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "check_out_date" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.check_out_date
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      {
        header: "Rooms & Guest",
        enableColumnFilter: false,
        Cell: ({ row, table }) => {
          const currentRoom = row.original.room;
          const currentGuest = row.original.guest;
          const currentRowIndex = row.index;

          // Get the next row if it exists
          const nextRow =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
              : null;

          // Compare current and next row values separately
          const isRoomDifferent = nextRow
            ? nextRow.room !== currentRoom
            : false;
          const isGuestDifferent = nextRow
            ? nextRow.guest !== currentGuest
            : false;

          return (
            <div className="whitespace-nowrap">
              <p className={isRoomDifferent ? "text-purple-500" : ""}>
                Room: {currentRoom || "N/A"}
              </p>
              <p className={isGuestDifferent ? "text-purple-500" : ""}>
                Guest: {currentGuest || "N/A"}
              </p>
            </div>
          );
        },
      },
      {
        accessorKey: "budget",
        header: "Budget",
        Cell: ({ cell }) => {
          // Function to generate a random color
          const getRandomColor = () => {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
          };
          // Function to determine if a color is light or dark
          const isColorLight = (color) => {
            // Convert hex to RGB
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            // Calculate the brightness (perceived brightness)
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 155; // Adjust threshold for light vs. dark
          };

          const randomColor = getRandomColor();
          const textColor = isColorLight(randomColor) ? "#000" : "#fff"; // Black for light, white for dark

          return (
            <div
              style={{
                backgroundColor: randomColor, // Set random color
                borderRadius: "0.25rem",
                color: textColor, // Set dynamic text color
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {cell.getValue()?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },
      {
        accessorKey: "paid_amount", // This is the new column for budget
        header: "Paid Amount",
        enableColumnFilter: false, // Enable filter for this column

        Cell: ({ cell }) => {
          // Function to generate a random color
          const getRandomColor = () => {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
          };
          // Function to determine if a color is light or dark
          const isColorLight = (color) => {
            // Convert hex to RGB
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            // Calculate the brightness (perceived brightness)
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 155; // Adjust threshold for light vs. dark
          };

          const randomColor = getRandomColor();
          const textColor = isColorLight(randomColor) ? "#000" : "#fff"; // Black for light, white for dark

          return (
            <div
              style={{
                backgroundColor: randomColor, // Set random color
                borderRadius: "0.25rem",
                color: textColor, // Set dynamic text color
                maxWidth: "15ch",
                padding: "0.25rem",
              }}
            >
              {cell.getValue()?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </div>
          );
        },
      },
      {
        accessorKey: "enquiryStatus", // Adjust this to match your actual data structure
        header: "Enquiry Status",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue()?.name || "N/A"; // Ensure we get the name, or "N/A" if missing
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.enquiryStatus?.name
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue}
            </span>
          );
        },
      },
      {
        accessorKey: "enquiry_payment_status", // Adjust this to match your actual data structure
        header: "Payment Status",
        Cell: ({ cell, row, table }) => {
          // Helper function to convert status to formatted display text
          const formatPaymentStatus = (status) => {
            const formattedStatus = {
              over_paid: "Over Paid",
              paid: "Paid",
              pending: "Pending",
              not_paid: "Not Paid",
            };
            return formattedStatus[status] || status; // Fallback to original if status is not in the map
          };
          const currentValue = cell.getValue() || "N/A"; // Ensure we get the name, or "N/A" if missing
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.enquiry_payment_status
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            nextValue !== null &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {formatPaymentStatus(currentValue)}
            </span>
          );
        },
      },

      {
        accessorKey: "special_requests",
        header: "Special Request",
        enableColumnFilter: false, // Enable filter for this column
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue(); // current row's "special_requests" value
          const currentRowIndex = row.index;

          // Check if there is a next row to compare against and ensure it's not the last row
          const nextValue =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.special_requests
              : null;

          // Check if the current value is different from the next row's value, but don't change color for the last row
          const isDifferent =
            nextValue !== currentValue &&
            currentRowIndex < table.getRowModel().rows.length - 1;

          return (
            <span className={isDifferent ? "text-purple-500" : ""}>
              {currentValue || "N/A"}
            </span>
          );
        },
      },
      // {
      //   accessorKey: "created_at", // Adjust this to match your actual data structure
      //   header: "Created Date",
      //   filterVariant: "select",

      //   Cell: ({ cell }) => {
      //     const createdAt = new Date(cell.getValue());
      //     const date = createdAt.toLocaleDateString(); // Get the date portion
      //     const time = createdAt.toLocaleTimeString(); // Get the time portion

      //     return (
      //       <div className="flex flex-col">
      //         <p
      //           className="font-semibold
      //         "
      //         >
      //           Date: <span className="font-light">{date}</span>
      //         </p>{" "}
      //         {/* Display the date */}
      //         <p
      //           className="font-semibold
      //         "
      //         >
      //           Time: <span className="font-light">{time}</span>
      //         </p>{" "}
      //         {/* Display the time */}
      //       </div>
      //     );
      //   },
      // },
      {
        accessorKey: "updated_at", // Adjust this to match your actual data structure
        header: "Updated Date",
        Cell: ({ cell, row, table }) => {
          const currentValue = cell.getValue();
          const currentDateObj = new Date(currentValue);
          const date = currentDateObj.toLocaleDateString(); // Get the date portion
          const time = currentDateObj.toLocaleTimeString(); // Get the time portion

          const currentRowIndex = row.index;

          // Get the next row if it exists
          const nextRow =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
              : null;

          // Initialize flags for date and time differences separately
          let isDateDifferent = false;
          let isTimeDifferent = false;

          if (nextRow) {
            const nextDateObj = new Date(nextRow.updated_at);
            const nextDate = nextDateObj.toLocaleDateString();
            const nextTime = nextDateObj.toLocaleTimeString();

            isDateDifferent = date !== nextDate;
            isTimeDifferent = time !== nextTime;
          }

          return (
            <div className="flex flex-col">
              <p
                className={`font-semibold ${
                  isDateDifferent ? "text-purple-500" : ""
                }`}
              >
                Date: <span className="font-light">{date}</span>
              </p>
              <p
                className={`font-semibold ${
                  isTimeDifferent ? "text-purple-500" : ""
                }`}
              >
                Time: <span className="font-light">{time}</span>
              </p>
            </div>
          );
        },
      },
      {
        accessorKey: "assignedToUser",
        header: "Assigned To",
        filterVariant: "select",
        enableColumnFilter: true,
        Cell: ({ cell, row, table }) => {
          const assignedUser = cell.getValue();
          const currentRowIndex = row.index;

          // Get the next row's assignedToUser (if it exists)
          const nextRowAssignedUser =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1]?.original
                  ?.assignedToUser
              : null;

          // Check if either the name or the phone number is different in the next row
          const isDifferent = nextRowAssignedUser
            ? nextRowAssignedUser?.name !== assignedUser?.name ||
              nextRowAssignedUser?.phone_no !== assignedUser?.phone_no
            : false;

          return (
            <div className="flex items-center gap-2">
              {assignedUser ? (
                <div>
                  <img
                    onClick={() => handleOpenModal(assignedUser)}
                    className="h-10 w-10 cursor-pointer rounded-full"
                    src={assignedUser?.full_path}
                    alt={assignedUser?.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = avtar; // Default avatar
                    }}
                  />
                </div>
              ) : (
                "N/A"
              )}
              {assignedUser && (
                <div>
                  <p className={isDifferent ? "text-purple-500" : ""}>
                    {assignedUser?.name}
                  </p>
                  <p className={isDifferent ? "text-purple-500" : ""}>
                    {assignedUser?.phone_no}
                  </p>
                </div>
              )}
            </div>
          );
        },
      },
      // {
      //   accessorKey: "createdByUser",
      //   header: "Created By",

      //   Cell: ({ cell }) => {
      //     const assignedBy = cell.getValue();

      //     return (
      //       <div className="flex items-center gap-2">
      //         <div>
      //           <img
      //             onClick={() => handleOpenModal(assignedBy)} // Wrap in an arrow function
      //             className="h-10 w-10 cursor-pointer rounded-full"
      //             src={assignedBy?.full_path}
      //             alt={assignedBy?.name}
      //             onError={(e) => {
      //               e.target.onerror = null;
      //               e.target.src = avtar; // Default avatar
      //             }}
      //           />
      //         </div>
      //         <div>
      //           <p>{assignedBy?.name}</p>
      //           <p>{assignedBy?.phone_no}</p>
      //         </div>
      //       </div>
      //     );
      //   },
      // },
      {
        accessorKey: "updatedByUser",
        header: "updated By",
        Cell: ({ cell, row, table }) => {
          const updatedBy = cell.getValue();
          const currentRowIndex = row.index;

          // Retrieve the next row's updatedByUser object (if available)
          const nextRow =
            currentRowIndex < table.getRowModel().rows.length - 1
              ? table.getRowModel().rows[currentRowIndex + 1].original
              : null;
          const nextUpdatedBy = nextRow ? nextRow.updatedByUser : null;

          // Treat the name and phone_no as a single unit.
          // If either property is different between the current and next row, flag as different.
          const isDifferent = nextUpdatedBy
            ? nextUpdatedBy?.name !== updatedBy?.name ||
              nextUpdatedBy?.phone_no !== updatedBy?.phone_no
            : false;

          return (
            <div className="flex items-center gap-2">
              {updatedBy ? (
                <>
                  <div className="tooltip" data-tip="Profile">
                    <img
                      onClick={() => handleOpenModal(updatedBy)}
                      className="h-10 w-10 cursor-pointer rounded-full"
                      src={updatedBy?.full_path}
                      alt={updatedBy?.name || "User Avatar"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = avtar; // Default avatar
                      }}
                    />
                  </div>
                  <div>
                    <p className={isDifferent ? "text-purple-500" : ""}>
                      {updatedBy?.name}
                    </p>
                    <p className={isDifferent ? "text-purple-500" : ""}>
                      {updatedBy?.phone_no}
                    </p>
                  </div>
                </>
              ) : (
                "N/A"
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "status",
        header: "Status",
        Cell: ({ row, cell }) => {
          const status = cell.getValue();
          const statusName = status;

          return (
            <div className="relative inline-flex items-center gap-1">
              <p className={getStatusTextColor(statusName)}>{statusName}</p>
            </div>
          );
        },
      },
    ],
    [data]
  );

  useEffect(() => {
    if (historydata) {
      setData(historydata.reverse()); // Ensure proper state update
    }
  }, [historydata]);

  return (
    <section className="">
      <ScrollToTopOnRouteChange />

      <div className="">
        {isModalOpen && (
          <UserInfoModal user={userProfile} onClose={handleCloseModal} />
        )}
      </div>
      <div
        className={`${History ? "" : "h-[100vh]"} bg-white dark:bg-gray-900`}
      >
        <div className="flex items-center justify-between p-5 font-semibold">
          <h2 className="text-3xl text-gray-900 dark:text-[#bb8e25]">
            History
          </h2>
          {!History && <GoBackButton />}
        </div>
        <div>
          {historydata.map((e, index) => {
            <h2 className="my-5 text-2xl" key={index}>
              Search Enquiry History {e?.parent_id}
            </h2>;
          })}
        </div>

        <MaterialReactTable
          columns={columns}
          data={data}
          enableColumnFilters={false} // Disable column filters
          initialState={{
            showColumnFilters: false, // Hide column filters
            pagination: { pageSize: data.length }, // Set the page size to the total data length
          }}
          enableColumnOrdering={false} // Disable column ordering
          enableGlobalFilter={false} // Disable global filter
          enablePagination={false} // Disable pagination feature
          manualPagination={true} // Ensure pagination is controlled manually
        />
      </div>
    </section>
  );
}
